import { Direction } from "@/models/Enums";
import { VehicleItem } from "@/modules/Quickform/models/Vehicle";
import { defineStore } from "pinia";

export type VehicleState = {
  vehicles: {
    outward: VehicleItem[];
    return: VehicleItem[];
  };
  isReturn: boolean;
  differentDetailsReturn: boolean;
};

export const getEmptyVehicleItem = () => {
  return { length: "0", licenseNumber: "", rental: false, resourceCode: "", fuelType: "" };
};

export const useVehicleStore = defineStore("vehicle", {
  state: () => {
    return {
      vehicles: {
        outward: [],
        return: [],
      },
      isReturn: false,
      differentDetailsReturn: false,
    } as VehicleState;
  },
  getters: {
    getVehiclesOfRoute:
      (state) =>
      (direction: Direction): VehicleItem[] => {
        switch (direction) {
          case Direction.Outward:
            return state.vehicles.outward;
          case Direction.Return:
            return state.vehicles.return;
        }
      },
    getDifferentDetails: (state) => {
      return state.differentDetailsReturn;
    },
    getVehiclesTotal: (state) => {
      if (!state.vehicles.outward.length && !state.vehicles.return.length)
        return "No vehicle";
      return `${state.vehicles.outward.length} vehicles${
        state.differentDetailsReturn
          ? ", " + state.vehicles.return.length + " vehicles"
          : ""
      }`;
    },
  },
  actions: {
    setDirectionQuantity(direction: Direction, quantity: number) {
      switch (direction) {
        case Direction.Outward:
          while (this.vehicles.outward.length < quantity) {
            this.vehicles.outward.push(getEmptyVehicleItem());
          }
          while (this.vehicles.outward.length > quantity) {
            this.vehicles.outward.splice(-1, 1);
          }
          break;
        case Direction.Return:
          while (this.vehicles.return.length < quantity) {
            this.vehicles.return.push(getEmptyVehicleItem());
          }
          while (this.vehicles.return.length > quantity) {
            this.vehicles.return.splice(-1, 1);
          }
          break;
      }
    },
    setIsReturn(isReturn: boolean) {
      this.isReturn = isReturn;
    },
    setDifferentDetails(hasDifferentDetails: boolean) {
      this.differentDetailsReturn = hasDifferentDetails;
    },
    setVehicles(direction: Direction, vehicles: VehicleItem[]) {
      if (direction === Direction.Outward) {
        this.vehicles.outward = vehicles;
      } else if (direction === Direction.Return) {
        this.vehicles.return = vehicles;
      }
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
